/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timecodes_Copied_SuccessInputs */



/**
* | output |
* | --- |
* | "Timecodes copied successfully" |
*
* @param {Timecodes_Copied_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timecodes_copied_success = /** @type {((inputs?: Timecodes_Copied_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timecodes_Copied_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Timecodes copiés avec succès")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zeitcodes erfolgreich kopiert")
	if (locale === "it") return /** @type {LocalizedString} */ ("Timecode copiati correttamente")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Временные метки успешно скопированы.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Códigos de tiempo copiados exitosamente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("时间码已成功复制")
	if (locale === "ja") return /** @type {LocalizedString} */ ("タイムコードが正常にコピーされました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टाइमकोड सफलतापूर्वक कॉपी हो गए")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Códigos de tempo copiados com sucesso.")
	return /** @type {LocalizedString} */ ("Timecodes copied successfully")
});